var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-wrapper field-wrapper--large",
      class: ["field-wrapper--" + _vm.field.type]
    },
    [
      _c("div", { staticClass: "field-group field-group--html" }, [
        _c("div", {
          domProps: {
            innerHTML: _vm._s(
              _vm.field.content.replace("--vehicleName--", _vm.vehicleName)
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }